// import external dependencies
import 'jquery';
import 'custom-event-polyfill';

// Import autoload dependencies
import './autoload/_bootstrap';
import './autoload/_ekkolightbox';
import './autoload/_fontawesome';
import './autoload/_slick';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import brokers from './routes/brokers';
import postTypeArchiveBroker from './routes/postTypeArchiveBroker';
import services from './routes/services';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  brokers,
  postTypeArchiveBroker,
  services,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
